import {Injectable} from '@angular/core';
import {forkJoin, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

import {ApiPublicService} from '../../lib/lib-ngx/web-services/api-public.service';
import {IHouseDetailsList} from '../../lib/lib-shared/models/House';

interface IPickupDetails {
  name: string;
  formattedAddress: string;
}

@Injectable({providedIn: 'root'})
export class PickupService {
  private pickupMap = new Map<string, IPickupDetails>();

  constructor(private apiPublicService: ApiPublicService) {}

  getPickup(pickupId: string): IPickupDetails | undefined {
    return this.pickupMap.get(pickupId);
  }

  loadPickupDetailsForHouseList(houseList: IHouseDetailsList[]): void {
    const houseWithPickupList = houseList.filter(house => !!house.shippingAddress.pickupId);

    if (!houseWithPickupList.length) {
      return;
    }

    const missingIdList = this.getMissingPickupIdList(houseWithPickupList);

    this.loadPickupList(missingIdList).subscribe()
  }

  private getMissingPickupIdList(houseList: IHouseDetailsList[]): string[] {
    const idList = houseList.map(h => h.shippingAddress.pickupId!)
    return Array.from(new Set(idList.filter(id => !this.pickupMap.has(id))));
  }

  private loadPickupList(idList: string[]): Observable<void> {
    return forkJoin(
      idList.map(id => this.apiPublicService.getPickupId(id, {})),
    ).pipe(
      map(results => {
        results.filter(Boolean).forEach(({id, name, route, postalCode, locality}) => {
          this.pickupMap.set(id, {
            name: name,
            formattedAddress: `${route}, ${postalCode} ${locality}`,
          });
        });
      }),
    );
  }
}
